import * as React from "react";
import { TransferInstructionQuery } from "../Resources/TransferInstructionQuery";
import { WizardLabel } from "../Resources/Content";
import { InvestmentTable } from "./StepOneComponent/InvestmentTable";
import { IInvestmentTransfer } from "../Stores/InvestmentTransferStoreStatic";
import { DestinationAccount } from "./StepOneComponent/DestinationAccount";
import { Lightbox, LightboxType } from "../../../../react-core/Html/Components/Lightbox";
import { TransferDestinationAccountModel } from "../../../../Wrap/Models/Domains/Transfer/TransferDestinationAccountModel";
import { MoveableSubAccountStore } from "../Stores/Variable";
import { ChangeOfBeneficialOwner } from "./StepOneComponent/ChangeOfBeneficialOwner";
import { TransferSourceAccounts } from "../../../../Wrap/Models/Domains/Transfer/TransferSourceAccounts";
import { SecurityType } from "../../../../Wrap/Constants/Enums/Domain/Instrument/SecurityType";
import { PartLoading } from "../../../../react-core/Html/PartLoading";
import { ServiceProposition } from "../../../../Wrap/Constants/Enums/ServiceProposition";

interface ITransferWizardStepTwoProps {
    onChange: (key: string, value: any, data?: any) => void;
    data: TransferInstructionQuery;
    investmentData: IInvestmentTransfer[];
    destinationAccount: TransferDestinationAccountModel;
    currentAccount: TransferSourceAccounts;
    isReview: boolean;
    isAuthorisation?: boolean;
    onAuthorise?: () => void;
    onReject?: () => void;
    onRef: (ref) => void;
}

interface ITransferWizardStepOneState {
    isConfirmed: boolean;
    isShowConfirm: boolean;
    isLoading?: boolean;
    displayAuthoriseOrRejectConfirmation: boolean;
    authoriseSelected?: boolean;
}

export class TransferWizardStepTwo extends React.Component<ITransferWizardStepTwoProps, ITransferWizardStepOneState> {
    constructor(props: any) {
        super(props);
        this.state = {
            isConfirmed: false,
            isShowConfirm: false,
            displayAuthoriseOrRejectConfirmation: false,
        };
    }

    render() {
        const hasValueInvestmentData: IInvestmentTransfer[] = [];
        this.props.investmentData.forEach((ele) => {
            if (ele.subInvestment) {
                const sub = [];
                ele.subInvestment.forEach((item) => {
                    if (item.moveQuantity > 0 || item.isMoveAll) {
                        sub.push(item);
                    }
                });
                if (sub.length > 0) {
                    hasValueInvestmentData.push({
                        detail: ele.detail,
                        isMoveAll: ele.isMoveAll,
                        moveQuantity: ele.moveQuantity,
                        subInvestment: sub,
                        isToggle: ele.isToggle,
                        amendBookCost: ele.amendBookCost,
                        acquisitionDate: ele.acquisitionDate,
                        CGT: ele.CGT,
                    });
                }
            } else {
                if (ele.isMoveAll || ele.moveQuantity > 0) {
                    hasValueInvestmentData.push(ele);
                }
            }
        });
        const showChangeOfBeneficialOwner = hasValueInvestmentData.some((ele) =>
            [SecurityType.Share, SecurityType.Bond].includes(ele.detail?.SecurityType)
        );
        return this.state.isLoading ? (
            <PartLoading isLoading={true}></PartLoading>
        ) : (
            <>
                <InvestmentTable
                    onChange={this.props.onChange}
                    data={hasValueInvestmentData}
                    isReview={this.props.isReview}
                    destinationAccount={this.props.destinationAccount}
                />
                <DestinationAccount
                    onChange={this.props.onChange}
                    data={this.props.destinationAccount}
                    isReview={this.props.isReview}
                    serviceProposition={
                        this.props.currentAccount
                            ? this.props.currentAccount.ServiceProposition
                            : ServiceProposition.NotSpecified
                    }
                />
                {showChangeOfBeneficialOwner && !this.props.isAuthorisation && (
                    <ChangeOfBeneficialOwner
                        currentAccount={this.props.currentAccount}
                        destinationAccount={this.props.destinationAccount}
                        onChange={this.props.onChange}
                        data={this.props.data}
                        isReview={false}
                        onRef={(ref) => this.props.onRef(ref)}
                    />
                )}
                {!this.props.isAuthorisation && (
                    <table className="data-table">
                        <thead>
                            <tr>
                                <th>{WizardLabel.confirm.title}</th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr>
                                <td>
                                    {WizardLabel.confirm.label}
                                    <div className="square-checkbox label-sr-only">
                                        <label className="controls-checkbox">
                                            <input
                                                type="checkbox"
                                                value="standard"
                                                checked={this.state.isConfirmed}
                                                onClick={() => this.onConfirmed()}
                                            />
                                            <span aria-hidden="true" className="gfx" />
                                        </label>
                                    </div>
                                </td>
                            </tr>
                        </tbody>
                    </table>
                )}
                {this.props.isAuthorisation && (
                    <div className="row">
                        <div className="col-1 col-3">
                            <button
                                className="btn secondary label-offset"
                                onClick={() => {
                                    this.onAuthoriseOrReject(false);
                                }}
                            >
                                Reject
                            </button>
                        </div>
                        <div className="col-9 col-2 col-right">
                            <button
                                className="btn primary label-offset"
                                onClick={() => {
                                    this.onAuthoriseOrReject(true);
                                }}
                            >
                                Authorise
                            </button>
                        </div>
                    </div>
                )}
                {this.state.isShowConfirm && this.state.isConfirmed && !this.props.isAuthorisation ? (
                    <Lightbox
                        show={this.state.isShowConfirm && this.state.isConfirmed}
                        title={"Confirmation"}
                        contentAfterTitle={null}
                        onClose={() => this.setState({ isShowConfirm: false })}
                        type={LightboxType.Modal}
                        unclosable={true}
                        noOverlay={false}
                        noAutofocus={true}
                        cssWrapper="is-default-lightbox is-narrow"
                    >
                        <p>
                            {`You have selected to move assets from a ${
                                MoveableSubAccountStore.getCurrentAccount().ProductDisplayName
                            } account to a ${
                                this.props.destinationAccount.ProductDisplayName
                            } account. Please review and confirm these product types and account numbers
                            are correct before submitting the request for processing.`}
                        </p>
                        <button className="btn primary" onClick={() => this.setState({ isShowConfirm: false })}>
                            OK
                        </button>
                    </Lightbox>
                ) : null}
                {this.renderAuthoriseOrRejectConfirmationBox()}
            </>
        );
    }

    private renderAuthoriseOrRejectConfirmationBox() {
        return (
            this.state.displayAuthoriseOrRejectConfirmation && (
                <Lightbox
                    show={this.state.displayAuthoriseOrRejectConfirmation}
                    title={"Confirmation"}
                    contentAfterTitle={null}
                    onClose={() => this.setState({ displayAuthoriseOrRejectConfirmation: false })}
                    type={LightboxType.Modal}
                    unclosable={true}
                    noOverlay={false}
                    noAutofocus={true}
                    cssWrapper="is-default-lightbox is-narrow"
                >
                    <p>{`Are you sure you wish to ${
                        this.state.authoriseSelected ? "authorise" : "reject"
                    } this wizard?`}</p>
                    <div className="row row-center">
                        <button
                            className="btn secondary mr-4"
                            onClick={() => this.setState({ displayAuthoriseOrRejectConfirmation: false })}
                        >
                            No
                        </button>
                        <button
                            className="btn primary"
                            onClick={() => {
                                this.setState({ displayAuthoriseOrRejectConfirmation: false, isLoading: true });
                                this.state.authoriseSelected ? this.props.onAuthorise() : this.props.onReject();
                            }}
                        >
                            Yes
                        </button>
                    </div>
                </Lightbox>
            )
        );
    }

    private onAuthoriseOrReject(authoriseSelected: boolean) {
        this.setState({ displayAuthoriseOrRejectConfirmation: true, authoriseSelected: authoriseSelected });
    }

    private onConfirmed(): void {
        this.props.onChange("Confirmed", !this.state.isConfirmed);
        this.setState((preState) => ({
            isConfirmed: !preState.isConfirmed,
            isShowConfirm: true,
        }));
    }
}
